import { type Settings } from './model';

const DATA_EXPORT_USAGE_ENHANCEMENTS = 'enable-data-export-usage-enhancements';

const overrides: { [flagKey: string]: unknown } = {
  [DATA_EXPORT_USAGE_ENHANCEMENTS]: false,
};

export const getBillingFlagOverrides = (): Readonly<{ [flagKey: string]: unknown }> => overrides;

export const syncBillingFlagOverrides = (settings: Partial<Settings>) => {
  if ('vitalstatistixDataExportObservability' in settings) {
    overrides[DATA_EXPORT_USAGE_ENHANCEMENTS] = settings.vitalstatistixDataExportObservability === true;
  }
};
